// FAQ Data - 20 preguntas frecuentes sobre colorimetría

export const faqData = [
    {
        id: 1,
        category: 'General',
        question: '¿Qué es exactamente la colorimetría personal?',
        answer: 'La colorimetría personal es un sistema que determina qué colores te favorecen más basándose en tu tono de piel, color de ojos y cabello natural. Se basa en la teoría del color y clasifica a las personas en "temporadas" (Primavera, Verano, Otoño, Invierno) según si tienen subtonos cálidos o fríos y su nivel de contraste natural.'
    },
    {
        id: 2,
        category: 'General',
        question: '¿Realmente funciona la colorimetría?',
        answer: 'Sí, está respaldada por principios científicos de la teoría del color y cómo los colores interactúan visualmente. Los colores que armonizan con tu subtono natural reflejan luz de manera que realza tu apariencia, mientras que los colores discordantes pueden hacer que te veas apagado o cansado. Miles de personas han experimentado resultados tangibles al aplicar colorimetría en su vestuario.'
    },
    {
        id: 3,
        category: 'Análisis',
        question: '¿Cómo funciona el análisis con IA de MyColors?',
        answer: 'Nuestro sistema de IA utiliza visión por computadora para analizar píxel a píxel tu tono de piel, subtono, color de cabello y ojos. Estos datos se comparan con una extensa base de datos de colorimetría estacional para encontrar tu coincidencia ideal. Aunque la precisión total depende de la calidad e iluminación de la foto y ninguna IA es infalible al 100%, nuestro algoritmo se refina constantemente para ofrecerte el resultado más fiable y cercano a una consultoría experta.'
    },
    {
        id: 4,
        category: 'Análisis',
        question: '¿Qué tipo de foto debo subir para mejores resultados?',
        answer: 'Para resultados óptimos, sube una foto con luz natural (no sol directo), sin maquillaje o con maquillaje muy natural, mirando de frente a la cámara, con el cabello visible y sin filtros. Evita fotos con iluminación artificial amarilla o con sombras fuertes en el rostro.'
    },
    {
        id: 5,
        category: 'Análisis',
        question: '¿Puedo confiar en el resultado automático?',
        answer: 'Nuestro análisis con IA tiene una precisión del 85-90% comparable a consultas profesionales. Sin embargo, es una herramienta orientativa. Si tienes dudas, puedes validar tu resultado probando físicamente los colores de tu paleta frente al espejo con luz natural y ver cuáles te hacen lucir más radiante.'
    },
    {
        id: 6,
        category: 'Temporadas',
        question: '¿Puedo ser de dos temporadas a la vez?',
        answer: 'Aunque la mayoría de personas tiene una temporada dominante, algunas están en el límite entre dos (por ejemplo, Primavera-Otoño si eres claramente cálida). En esos casos, puedes tomar colores de ambas paletas, priorizando siempre la temperatura correcta (cálido o frío) que es el factor más importante.'
    },
    {
        id: 7,
        category: 'Temporadas',
        question: '¿Mi temporada puede cambiar con la edad o el bronceado?',
        answer: 'No. Tu temporada está determinada por tu subtono de piel, que es genético y permanente. El bronceado solo oscurece temporalmente tu tono superficial pero no cambia el subtono subyacente. Tus colores favorables seguirán siendo los mismos toda tu vida.'
    },
    {
        id: 8,
        category: 'Aplicación',
        question: '¿Significa que nunca puedo usar colores fuera de mi paleta?',
        answer: 'Puedes usar cualquier color que desees, pero los de tu paleta te harán lucir objetivamente mejor. Si quieres usar un color fuera de tu paleta, intenta alejarlo de tu rostro (pantalones, zapatos, bolsos) o combínalo con colores favorables cerca de tu cara (bufanda, collar, chaqueta).'
    },
    {
        id: 9,
        category: 'Aplicación',
        question: '¿Cómo empiezo a aplicar mi paleta en mi armario actual?',
        answer: 'Empieza sin tirar nada. Identifica qué prendas actuales ya están en tu paleta (te sorprenderás). Al comprar nuevas prendas, prioriza colores de tu paleta para piezas cercanas al rostro. Con el tiempo, tu armario se transformará naturalmente hacia una colección más coherente y favorecedora.'
    },
    {
        id: 10,
        category: 'Aplicación',
        question: '¿La colorimetría aplica también al maquillaje?',
        answer: 'Absolutamente. Los mismos principios aplican: si eres cálida, usa bases con subtono dorado, labiales coral/melocotón, sombras en tonos tierra. Si eres fría, usa bases rosadas, labiales fucsia/rosa, sombras en grises y morados. El maquillaje en tu temperatura correcta se verá más natural.'
    },
    {
        id: 11,
        category: 'Problemas',
        question: 'No me gusta el negro, pero soy Invierno. ¿Qué hago?',
        answer: 'Nadie te obliga a usar negro. Incluso siendo Invierno, tienes decenas de otros colores en tu paleta: azul royal, fucsia, blanco brillante, rojo cereza, etc. El negro es solo una opción dentro de tu paleta, no un requisito. Enfócate en los colores que amas de tu temporada.'
    },
    {
        id: 12,
        category: 'Problemas',
        question: 'Los colores "correctos" para mí no me gustan. ¿Y ahora?',
        answer: 'Dale tiempo a tu ojo para adaptarse. A veces estamos acostumbrados a colores que no nos favorecen y pueden parecer "extraños" al principio. Prueba los colores de tu paleta cerca de tu rostro con luz natural; verás objetivamente la diferencia. La preferencia suele alinearse con lo que objetivamente se ve mejor una vez que lo experimentas.'
    },
    {
        id: 13,
        category: 'Avanzado',
        question: '¿Qué son las subtemporadas (12 temporadas)?',
        answer: 'El sistema de 12 temporadas subdivide cada estación básica en tres subtipos según qué característica domina: temperatura, valor o saturación. Por ejemplo, Primavera se divide en Primavera Clara, Primavera Cálida y Primavera Brillante. Es un sistema más refinado, pero dominar las 4 temporadas básicas es suficiente para el 90% de los beneficios.'
    },
    {
        id: 14,
        category: 'Avanzado',
        question: '¿Cómo afecta el contraste a mi paleta?',
        answer: 'El contraste (diferencia de tono entre tu piel, cabello y ojos) determina la intensidad de colores que te favorece. Alto contraste necesita colores saturados y combinaciones contrastantes. Bajo contraste se ve mejor en colores suaves y combinaciones ton-sur-ton. Es tan importante como la temperatura del color.'
    },
    {
        id: 15,
        category: 'Compras',
        question: '¿Cómo saber si un color en tienda está en mi paleta?',
        answer: 'Con práctica, aprenderás a identificar "tu versión" de cada color al instante. Al principio, lleva una foto de tu paleta en el móvil. Pregúntate: ¿este verde tiene base amarilla (cálido) o azul (frío)? ¿Es lo suficientemente claro/oscuro para mi contraste? También puedes sostenerlo cerca de tu rostro y ver si te ilumina o apaga.'
    },
    {
        id: 16,
        category: 'Compras',
        question: '¿Vale la pena invertir en consultoría presencial?',
        answer: 'Si el presupuesto lo permite y quieres análisis muy detallado + revisión de armario personalizada, sí. Pero el análisis con IA es suficiente para la mayoría. Primero descubre tu temporada con IA, aplícala unos meses, y si quieres refinamiento profesional, considera consultoría después.'
    },
    {
        id: 17,
        category: 'Hombres',
        question: '¿La colorimetría funciona para hombres?',
        answer: 'Por supuesto. Los mismos principios aplican. Un hombre Primavera se verá mejor en camisas beige/camel, corbatas coral, trajes navy. Un Invierno brillará en camisas blancas impecables, corbatas azul royal, trajes carbón. La colorimetría puede ser la ventaja secreta de cualquier hombre que quiera lucir más profesional y atractivo.'
    },
    {
        id: 18,
        category: 'Cabello',
        question: '¿Puedo teñirme el cabello de cualquier color?',
        answer: 'Técnicamente sí, pero te favorecerá más si eliges tonos dentro de tu temperatura. Si eres cálida, opta por rubios dorados, castaños cálidos, cobrizos. Si eres fría, elige rubios ceniza, castaños fríos, negros azulados. Teñir en la temperatura opuesta puede crear disonancia con tu subtono de piel.'
    },
    {
        id: 19,
        category: 'Neutrales',
        question: '¿Qué neutrales debería usar según mi temporada?',
        answer: 'Cálidas (Primavera/Otoño): beige, camel, marrón, crema, navy. Frías (Verano/Invierno): gris, carbón, negro (solo Invierno), blanco puro, navy. Los neutrales correctos son la base de un armario versátil y te permiten usar tus colores acento sin esfuerzo.'
    },
    {
        id: 20,
        category: 'Resultados',
        question: '¿Cuánto tiempo hasta ver resultados aplicando colorimetría?',
        answer: 'Inmediato. La primera vez que te pongas un color de tu paleta frente al espejo, verás la diferencia en cómo ilumina tu rostro. A nivel práctico, en 2-3 meses al incorporar piezas nuevas en tu paleta, notarás que combinar outfits es más fácil y recibes más cumplidos sobre tu apariencia.'
    }
]

// Helper function to get FAQs by category
export const getFAQsByCategory = (category) => {
    if (!category) return faqData
    return faqData.filter(faq => faq.category === category)
}

// Get all unique categories
export const faqCategories = [...new Set(faqData.map(faq => faq.category))]
